import AlertMobile, { AlertProps } from '@vkontakte/vkui/dist/components/Alert/Alert';
import AlertDesktop from './AlertDesktop';
import { getPlatformComponent } from '../utils/getPlatformComponent';

export default getPlatformComponent<AlertProps>({ mobile: AlertMobile as any, desktop: AlertDesktop });
